/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AdmissionAuxPatient from './admission-aux-patient';
import AdmissionAuxPatientDetail from './admission-aux-patient-detail';
import AdmissionAuxPatientUpdate from './admission-aux-patient-update';
import AdmissionAuxPatientDeleteDialog from './admission-aux-patient-delete-dialog';

const AdmissionAuxPatientRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AdmissionAuxPatient />} />
    <Route path="new" element={<AdmissionAuxPatientUpdate />} />
    <Route path=":id">
      <Route index element={<AdmissionAuxPatientDetail />} />
      <Route path="edit" element={<AdmissionAuxPatientUpdate />} />
      <Route path="delete" element={<AdmissionAuxPatientDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AdmissionAuxPatientRoutes;
